import { VirtualPageviewTracker } from './GTM/components/VirtualPageviewTracker';

type TrackingProps = {
  pageType?: string;
}

export const Tracking = ({ pageType }: TrackingProps) => {
  return (
    <>
      <VirtualPageviewTracker pageType={pageType} />
    </>
  );
};
